import firebase from 'gatsby-plugin-firebase'
import { API } from '../sharedBetweenServerAndClient__DO_NOT_EDIT/types'
import { appConfig } from '../appConfig'
import { localCache } from './browserStorage'

interface FunctionTypes {
  createGame: {
    payload: API.CreateGamePayload
    response: API.CreateGameResponse
  }
  createGameHandAction: {
    payload: API.CreateGameHandActionPayload
    response: null
  }
  setCurrentUserTableState: {
    payload: API.SetCurrentUserTableState
    response: null
  }
  voteToSetUserTableState: {
    payload: API.VoteToSetUserTableState
    response: null
  }
  giveUserAdditionalChips: {
    payload: API.GiveUserAdditionalChips
    response: null
  }
  startGame: {
    payload: API.StartGamePayload
    response: null
  }
  requestAccessToGame: {
    payload: API.RequestAccessToGame
    response: null
  }
  respondToGameAccessRequest: {
    payload: API.RespondToGameAccessRequest
    response: null
  }
  showCurrentUsersCards: {
    payload: API.ShowCurrentUsersCards
    response: null
  }
  updateGameRules: {
    payload: API.UpdateGameRules
    response: null
  }
}

export const getFunction = <T extends keyof FunctionTypes>(endpoint: T) => {
  const fn: (
    payload: FunctionTypes[T]['payload'],
  ) => Promise<{ data: FunctionTypes[T]['response'] }> = appConfig.IS_BROWSER
    ? (data) => firebase.functions().httpsCallable('api')({ ...data, endpoint: endpoint })
    : () => {
        return null as any
      }
  return fn
}

interface PendingAction<T extends keyof FunctionTypes = any> {
  functionName: T
  payload: FunctionTypes[T]
}

export const getCachedPendingActions = () => {
  const pendingActions: PendingAction[] = localCache.getItem('pendingActions') || []
  return pendingActions
}

export const generateCachedPendingAction = <T extends keyof FunctionTypes>(
  functionName: T,
  payload: FunctionTypes[T],
) => {
  const pendingActions = getCachedPendingActions()
  pendingActions.push({ functionName, payload })
  localCache.setItem('pendingActions', pendingActions)
}
